module.exports = __webpack_public_path__ + "fonts/Euclid Circular B SemiBold.9d1a480c.woff";